import { render } from "./BottomMenuMobile.vue?vue&type=template&id=2791268b&scoped=true"
import script from "./BottomMenuMobile.vue?vue&type=script&lang=js"
export * from "./BottomMenuMobile.vue?vue&type=script&lang=js"

import "./BottomMenuMobile.vue?vue&type=style&index=0&id=2791268b&lang=stylus&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2791268b"]])

export default __exports__